import React from "react"
import type { PaginationMeta } from "../../Questions/types"
import "./AssessorPagination.style.scss"

interface AssessorPaginationProps {
  pagination: PaginationMeta | null
  loading: boolean
  onPageChange: (page: number) => void
}

const AssessorPagination = ({
  pagination,
  loading,
  onPageChange,
}: AssessorPaginationProps) => {
  if (!pagination || pagination.total_pages <= 1) return null
  const page = pagination.page || 1

  return (
    <div className="assessor-pagination">
      <button
        type="button"
        disabled={page <= 1 || loading}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </button>
      <span>
        Page {page} of {pagination.total_pages}
        {pagination.total > 0 ? ` · ${pagination.total} total` : ""}
      </span>
      <button
        type="button"
        disabled={page >= pagination.total_pages || loading}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </div>
  )
}

export default AssessorPagination
